const NY_IMAGES_BASE = "/route-builder/ny";

const NEW_YORK = {
	id: "nueva-york",
	name: "Nueva York",
	emoji: "🗽",
	color: "#FF6B35",
	colorLight: "#FFF4ED",
	colorAccent: "#E85D26",

	backgrounds: [
		{
			id: "mapa",
			name: "Acuarela",
			image: `${NY_IMAGES_BASE}/fondo-mapa.png`,
			gradient: "#E8F4FC",
			colorStops: [0, "#E8F4FC", 1, "#F5F0E1"],
			text: "#2c3e50",
			textSecondary: "rgba(44,62,80,0.75)",
			accent: "#5b8fa8",
			stopBg: "rgba(255,255,255,0.7)",
			stopBorder: "rgba(91,143,168,0.35)",
			line: "rgba(91,143,168,0.65)",
			watermark: "rgba(44,62,80,0.4)",
			titleShadow: "0 2px 8px rgba(255,255,255,0.8)",
		},
		{
			id: "mapa-2",
			name: "Otoño",
			image: `${NY_IMAGES_BASE}/fondo-mapa-2.png`,
			gradient: "#E8E4D8",
			colorStops: [0, "#E8E4D8", 1, "#D4CDB8"],
			text: "#2c3e50",
			textSecondary: "rgba(44,62,80,0.75)",
			accent: "#8a7a5a",
			stopBg: "rgba(255,255,255,0.7)",
			stopBorder: "rgba(138,122,90,0.35)",
			line: "rgba(138,122,90,0.65)",
			watermark: "rgba(44,62,80,0.4)",
			titleShadow: "0 2px 8px rgba(255,255,255,0.8)",
		},
		{
			id: "mapa-3",
			name: "Día claro",
			image: `${NY_IMAGES_BASE}/fondo-mapa-3.png`,
			gradient: "#E6F3FB",
			colorStops: [0, "#E6F3FB", 1, "#F5F0E1"],
			text: "#2c3e50",
			textSecondary: "rgba(44,62,80,0.75)",
			accent: "#3d8bb8",
			stopBg: "rgba(255,255,255,0.7)",
			stopBorder: "rgba(61,139,184,0.35)",
			line: "rgba(61,139,184,0.65)",
			watermark: "rgba(44,62,80,0.4)",
			titleShadow: "0 2px 8px rgba(255,255,255,0.8)",
		},
		{
			id: "mapa-4",
			name: "Papel",
			image: `${NY_IMAGES_BASE}/fondo-mapa-4.png`,
			gradient: "#F3F1EA",
			colorStops: [0, "#F3F1EA", 1, "#E4E0D4"],
			text: "#2c3e50",
			textSecondary: "rgba(44,62,80,0.75)",
			accent: "#6b8f71",
			stopBg: "rgba(255,255,255,0.7)",
			stopBorder: "rgba(107,143,113,0.35)",
			line: "rgba(107,143,113,0.65)",
			watermark: "rgba(44,62,80,0.4)",
			titleShadow: "0 2px 8px rgba(255,255,255,0.8)",
		},
		{
			id: "mapa-5",
			name: "Pop",
			image: `${NY_IMAGES_BASE}/fondo-mapa-5.png`,
			gradient: "#F8D4E4",
			colorStops: [0, "#F8D4E4", 1, "#F5F0E1"],
			text: "#2c3e50",
			textSecondary: "rgba(44,62,80,0.75)",
			accent: "#e85d8c",
			stopBg: "rgba(255,255,255,0.75)",
			stopBorder: "rgba(232,93,140,0.35)",
			line: "rgba(232,93,140,0.6)",
			watermark: "rgba(44,62,80,0.4)",
			titleShadow: "0 2px 8px rgba(255,255,255,0.8)",
		},
		{
			id: "mapa-6",
			name: "Pastel",
			image: `${NY_IMAGES_BASE}/fondo-mapa-6.png`,
			gradient: "#E8F4FC",
			colorStops: [0, "#E8F4FC", 1, "#FFF5E8"],
			text: "#2c3e50",
			textSecondary: "rgba(44,62,80,0.75)",
			accent: "#7eb8d4",
			stopBg: "rgba(255,255,255,0.7)",
			stopBorder: "rgba(126,184,212,0.35)",
			line: "rgba(126,184,212,0.65)",
			watermark: "rgba(44,62,80,0.4)",
			titleShadow: "0 2px 8px rgba(255,255,255,0.8)",
		},
		{
			id: "mapa-7",
			name: "Kawaii",
			image: `${NY_IMAGES_BASE}/fondo-mapa-7.png`,
			gradient: "#F6EEF6",
			colorStops: [0, "#F6EEF6", 1, "#F5F0E8"],
			text: "#2c3e50",
			textSecondary: "rgba(44,62,80,0.75)",
			accent: "#c77db5",
			stopBg: "rgba(255,255,255,0.7)",
			stopBorder: "rgba(199,125,181,0.35)",
			line: "rgba(199,125,181,0.6)",
			watermark: "rgba(44,62,80,0.4)",
			titleShadow: "0 2px 8px rgba(255,255,255,0.8)",
		},
		{
			id: "mapa-8",
			name: "Central Park",
			image: `${NY_IMAGES_BASE}/fondo-mapa-8.png`,
			gradient: "#E8F5E9",
			colorStops: [0, "#E8F5E9", 1, "#F5F0E8"],
			text: "#2c3e50",
			textSecondary: "rgba(44,62,80,0.75)",
			accent: "#5a9a6a",
			stopBg: "rgba(255,255,255,0.7)",
			stopBorder: "rgba(90,154,106,0.35)",
			line: "rgba(90,154,106,0.65)",
			watermark: "rgba(44,62,80,0.4)",
			titleShadow: "0 2px 8px rgba(255,255,255,0.8)",
		},
		{
			id: "mapa-9",
			name: "Brooklyn",
			image: `${NY_IMAGES_BASE}/fondo-mapa-9.png`,
			gradient: "#F5F0E1",
			colorStops: [0, "#E8F4FC", 1, "#F5F0E1"],
			text: "#2c3e50",
			textSecondary: "rgba(44,62,80,0.75)",
			accent: "#6a8fad",
			stopBg: "rgba(255,255,255,0.7)",
			stopBorder: "rgba(106,143,173,0.35)",
			line: "rgba(106,143,173,0.65)",
			watermark: "rgba(44,62,80,0.4)",
			titleShadow: "0 2px 8px rgba(255,255,255,0.8)",
		},
		{
			id: "mapa-10",
			name: "Lower Manhattan",
			image: `${NY_IMAGES_BASE}/fondo-mapa-10.png`,
			gradient: "#F5F0E1",
			colorStops: [0, "#E8F4FC", 1, "#F5F0E1"],
			text: "#2c3e50",
			textSecondary: "rgba(44,62,80,0.75)",
			accent: "#6a8fad",
			stopBg: "rgba(255,255,255,0.7)",
			stopBorder: "rgba(106,143,173,0.35)",
			line: "rgba(106,143,173,0.65)",
			watermark: "rgba(44,62,80,0.4)",
			titleShadow: "0 2px 8px rgba(255,255,255,0.8)",
		},
	],

	places: [
		{
			id: "times-square",
			name: "Times Square",
			emoji: "🌆",
			zone: "Midtown",
			image: `${NY_IMAGES_BASE}/times-square.png`,
		},
		{
			id: "central-park",
			name: "Central Park",
			emoji: "🌳",
			zone: "Central Park",
			image: `${NY_IMAGES_BASE}/central-park.png`,
		},
		{
			id: "empire-state",
			name: "Empire State Building",
			emoji: "🏢",
			zone: "Midtown",
			image: `${NY_IMAGES_BASE}/empire-state-building.png`,
		},
		{
			id: "top-of-the-rock",
			name: "Top of the Rock",
			emoji: "🔭",
			zone: "Midtown",
			image: `${NY_IMAGES_BASE}/top-of-the-rock.png`,
		},
		{
			id: "estatua-libertad",
			name: "Estatua de la Libertad",
			emoji: "🗽",
			zone: "Liberty Island",
			image: `${NY_IMAGES_BASE}/estatua-libertad.png`,
		},
		{
			id: "one-world-trade",
			name: "One World Trade Center",
			emoji: "🏙️",
			zone: "Financial District",
			image: `${NY_IMAGES_BASE}/One-World-Trade-Center.png`,
		},
		{
			id: "oculus",
			name: "Oculus",
			emoji: "🤍",
			zone: "Financial District",
			image: `${NY_IMAGES_BASE}/oculus.png`,
		},
		{
			id: "broadway",
			name: "Broadway",
			emoji: "🎭",
			zone: "Midtown",
			image: `${NY_IMAGES_BASE}/broadway.png`,
		},
		{
			id: "little-island",
			name: "Little Island",
			emoji: "🏝️",
			zone: "Chelsea y Hudson River",
			image: `${NY_IMAGES_BASE}/little-island.png`,
		},
		{
			id: "met",
			name: "The Met",
			emoji: "🏛️",
			zone: "Upper East Side",
			image: `${NY_IMAGES_BASE}/met.png`,
		},
		{
			id: "museo-historia-natural",
			name: "Museo de Historia Natural",
			emoji: "🦕",
			zone: "Upper West Side",
			image: `${NY_IMAGES_BASE}/museo-historia-natural.png`,
		},
		{
			id: "brooklyn-bridge",
			name: "Brooklyn Bridge",
			emoji: "🌉",
			zone: "Brooklyn",
			image: `${NY_IMAGES_BASE}/puente-brooklyn.png`,
		},
		{
			id: "dumbo",
			name: "DUMBO",
			emoji: "🏙️",
			zone: "Brooklyn",
			image: `${NY_IMAGES_BASE}/dumbo.png`,
		},
		{
			id: "chinatown",
			name: "Chinatown",
			emoji: "🏮",
			zone: "Lower Manhattan",
			image: `${NY_IMAGES_BASE}/chinatown.png`,
		},
		{
			id: "soho",
			name: "SoHo",
			emoji: "🛍️",
			zone: "Lower Manhattan",
			image: `${NY_IMAGES_BASE}/soho.png`,
		},
		{
			id: "wall-street",
			name: "Wall Street",
			emoji: "💰",
			zone: "Financial District",
			image: `${NY_IMAGES_BASE}/wall-street.png`,
		},
		{
			id: "grand-central",
			name: "Grand Central",
			emoji: "🚂",
			zone: "Midtown",
			image: `${NY_IMAGES_BASE}/Grand-Central-Terminal.png`,
		},
		{
			id: "chelsea-market",
			name: "Chelsea Market",
			emoji: "🍕",
			zone: "Chelsea y Hudson River",
			image: `${NY_IMAGES_BASE}/chelsea-market.png`,
		},
		{
			id: "little-italy",
			name: "Little Italy",
			emoji: "🍝",
			zone: "Lower Manhattan",
			image: `${NY_IMAGES_BASE}/little-italy.png`,
		},
		{
			id: "public-library",
			name: "NY Public Library",
			emoji: "📚",
			zone: "Midtown",
			image: `${NY_IMAGES_BASE}/public-library-ny.png`,
		},
		{
			id: "fifth-ave",
			name: "5th Avenue",
			emoji: "🛍️",
			zone: "Midtown",
			image: `${NY_IMAGES_BASE}/5th-ave.png`,
		},
		{
			id: "rockefeller-center",
			name: "Rockefeller Center",
			emoji: "🎄",
			zone: "Midtown",
			image: `${NY_IMAGES_BASE}/rockefeller-center.png`,
		},
		{
			id: "bryant-park",
			name: "Bryant Park",
			emoji: "🌳",
			zone: "Midtown",
			image: `${NY_IMAGES_BASE}/bryant-park.png`,
		},
		{
			id: "moma",
			name: "MoMA",
			emoji: "🎨",
			zone: "Midtown",
			image: `${NY_IMAGES_BASE}/moma.png`,
		},
		{
			id: "summit",
			name: "Summit One Vanderbilt",
			emoji: "🔭",
			zone: "Midtown",
			image: `${NY_IMAGES_BASE}/summit.png`,
		},
		{
			id: "macys",
			name: "Macy's",
			emoji: "🛍️",
			zone: "Midtown",
			image: `${NY_IMAGES_BASE}/macys.png`,
		},
		{
			id: "madison-square-garden",
			name: "Madison Square Garden",
			emoji: "🏟️",
			zone: "Midtown",
			image: `${NY_IMAGES_BASE}/madison-square-garden.png`,
		},
		{
			id: "flatiron",
			name: "Flatiron Building",
			emoji: "🏢",
			zone: "Midtown",
			image: `${NY_IMAGES_BASE}/flatiron-building.png`,
		},
		{
			id: "union-square",
			name: "Union Square",
			emoji: "🌳",
			zone: "Greenwich Village",
			image: `${NY_IMAGES_BASE}/union-square.png`,
		},
		{
			id: "washington-square",
			name: "Washington Square",
			emoji: "⛲",
			zone: "Greenwich Village",
			image: `${NY_IMAGES_BASE}/Washington-square.png`,
		},
		{
			id: "greenwich-village",
			name: "Greenwich Village",
			emoji: "🏘️",
			zone: "Greenwich Village",
			image: `${NY_IMAGES_BASE}/greenwich-village.png`,
		},
		{
			id: "high-line",
			name: "High Line",
			emoji: "🚶",
			zone: "Chelsea y Hudson River",
			image: `${NY_IMAGES_BASE}/high-line.png`,
		},
		{
			id: "hudson-yards",
			name: "Hudson Yards",
			emoji: "🏙️",
			zone: "Hudson Yards",
			image: `${NY_IMAGES_BASE}/hudson-yards.png`,
		},
		{
			id: "edge",
			name: "The Edge",
			emoji: "🔭",
			zone: "Hudson Yards",
			image: `${NY_IMAGES_BASE}/edge.png`,
		},
		{
			id: "battery-park",
			name: "Battery Park",
			emoji: "🌳",
			zone: "Financial District",
			image: `${NY_IMAGES_BASE}/battery-park.png`,
		},
		{
			id: "memorial-11s",
			name: "Memorial 11S",
			emoji: "🕊️",
			zone: "Financial District",
			image: `${NY_IMAGES_BASE}/memorial-11s.png`,
		},
		{
			id: "ellis-island",
			name: "Ellis Island",
			emoji: "⛴️",
			zone: "Liberty Island",
			image: `${NY_IMAGES_BASE}/ellis-island.png`,
		},
		{
			id: "columbus-park",
			name: "Columbus Park",
			emoji: "🌳",
			zone: "Lower Manhattan",
			image: `${NY_IMAGES_BASE}/columbus-park.png`,
		},
		{
			id: "williamsburg",
			name: "Williamsburg",
			emoji: "🌉",
			zone: "Brooklyn",
			image: `${NY_IMAGES_BASE}/Williamsburg.png`,
		},
		{
			id: "brooklyn-bridge-park",
			name: "Brooklyn Bridge Park",
			emoji: "🌳",
			zone: "Brooklyn",
			image: `${NY_IMAGES_BASE}/brooklyn-bridge-park.png`,
		},
		{
			id: "brooklyn-heights",
			name: "Brooklyn Heights",
			emoji: "🏘️",
			zone: "Brooklyn",
			image: `${NY_IMAGES_BASE}/brooklyn-heights.png`,
		},
		{
			id: "bushwick",
			name: "Bushwick",
			emoji: "🎨",
			zone: "Brooklyn",
			image: `${NY_IMAGES_BASE}/Bushwick.png`,
		},
		{
			id: "janes-carousel",
			name: "Jane's Carousel",
			emoji: "🎠",
			zone: "Brooklyn",
			image: `${NY_IMAGES_BASE}/jane-s-carousel.png`,
		},
		{
			id: "pebble-beach",
			name: "Pebble Beach",
			emoji: "🏖️",
			zone: "Brooklyn",
			image: `${NY_IMAGES_BASE}/Pebble-beach.png`,
		},
		{
			id: "manhattan-bridge",
			name: "Manhattan Bridge",
			emoji: "🌉",
			zone: "Brooklyn",
			image: `${NY_IMAGES_BASE}/puente-manhattan.png`,
		},
		{
			id: "time-out-market",
			name: "Time Out Market",
			emoji: "🍽️",
			zone: "Brooklyn",
			image: `${NY_IMAGES_BASE}/time-out-market.png`,
		},
		{
			id: "st-ann-warehouse",
			name: "St. Ann's Warehouse",
			emoji: "🎭",
			zone: "Brooklyn",
			image: `${NY_IMAGES_BASE}/St-Ann-Warehouse.png`,
		},
		{
			id: "coney-island",
			name: "Coney Island",
			emoji: "🎢",
			zone: "Brooklyn",
			image: `${NY_IMAGES_BASE}/Coney-Island.png`,
		},
		{
			id: "prospect-park",
			name: "Prospect Park",
			emoji: "🌳",
			zone: "Brooklyn",
			image: `${NY_IMAGES_BASE}/Prospect-Park.png`,
		},
		{
			id: "dyker-heights",
			name: "Dyker Heights",
			emoji: "🎄",
			zone: "Brooklyn",
			image: `${NY_IMAGES_BASE}/dyker-heights.png`,
		},
		{
			id: "toro-bolsa",
			name: "Toro de Wall Street",
			emoji: "🐂",
			zone: "Financial District",
			image: `${NY_IMAGES_BASE}/toro-de-la-bolsa.png`,
		},
		{
			id: "pier-57",
			name: "Pier 57",
			emoji: "🚢",
			zone: "Chelsea y Hudson River",
			image: `${NY_IMAGES_BASE}/pier-57.png`,
		},
		{
			id: "fearless-girl",
			name: "Fearless Girl",
			emoji: "👧",
			zone: "Financial District",
			image: `${NY_IMAGES_BASE}/Fearless-Girl.png`,
		},
		{
			id: "one-world-observatory",
			name: "One World Observatory",
			emoji: "🔭",
			zone: "Financial District",
			image: `${NY_IMAGES_BASE}/One-World-Observatory.png`,
		},
		{
			id: "the-vessel",
			name: "The Vessel",
			emoji: "🏗️",
			zone: "Hudson Yards",
			image: `${NY_IMAGES_BASE}/the-vessel.png`,
		},
		{
			id: "tribeca",
			name: "Tribeca",
			emoji: "🏙️",
			zone: "Lower Manhattan",
			image: `${NY_IMAGES_BASE}/tribeca.png`,
		},
		{
			id: "trinity-church",
			name: "Trinity Church",
			emoji: "⛪",
			zone: "Financial District",
			image: `${NY_IMAGES_BASE}/trinity-church.png`,
		},
		{
			id: "belvedere-castle",
			name: "Belvedere Castle",
			emoji: "🏰",
			zone: "Central Park",
			image: `${NY_IMAGES_BASE}/Belvedere-Castle.png`,
		},
		{
			id: "bethesda-terrace",
			name: "Bethesda Terrace",
			emoji: "⛲",
			zone: "Central Park",
			image: `${NY_IMAGES_BASE}/Bethesda-Terrace.png`,
		},
		{
			id: "bow-bridge",
			name: "Bow Bridge",
			emoji: "🌉",
			zone: "Central Park",
			image: `${NY_IMAGES_BASE}/Bow-Bridge.png`,
		},
		{
			id: "gapstow-bridge",
			name: "Gapstow Bridge",
			emoji: "🌉",
			zone: "Central Park",
			image: `${NY_IMAGES_BASE}/Gapstow-Bridge.png`,
		},
		{
			id: "jacqueline-kennedy-onassis-reservoir",
			name: "Jacqueline Kennedy Onassis Reservoir",
			emoji: "💧",
			zone: "Central Park",
			image: `${NY_IMAGES_BASE}/Jacqueline-Kennedy-Onassis-Reservoir.png`,
		},
		{
			id: "strawberry-fields",
			name: "Strawberry Fields",
			emoji: "🍓",
			zone: "Central Park",
			image: `${NY_IMAGES_BASE}/Strawberry-Fields.png`,
		},
		{
			id: "the-mall",
			name: "The Mall",
			emoji: "🌳",
			zone: "Central Park",
			image: `${NY_IMAGES_BASE}/the-mall.png`,
		},
		{
			id: "canal-street",
			name: "Canal Street",
			emoji: "🛍️",
			zone: "Lower Manhattan",
			image: `${NY_IMAGES_BASE}/canal-street.png`,
		},
		{
			id: "alice-in-wonderland",
			name: "Alice in Wonderland",
			emoji: "🐇",
			zone: "Central Park",
			image: `${NY_IMAGES_BASE}/Alice-in-Wonderland.png`,
		},
		{
			id: "sheep-meadow",
			name: "Sheep Meadow",
			emoji: "🐑",
			zone: "Central Park",
			image: `${NY_IMAGES_BASE}/Sheep-Meadow.png`,
		},
		{
			id: "loeb-boathouse",
			name: "The Loeb Boathouse",
			emoji: "🚣",
			zone: "Central Park",
			image: `${NY_IMAGES_BASE}/The-Loeb-Boathouse.png`,
		},
		{
			id: "guggenheim",
			name: "Guggenheim Museum",
			emoji: "🌀",
			zone: "Upper East Side",
			image: `${NY_IMAGES_BASE}/Guggenheim-Museum.png`,
		},
		{
			id: "casa-carrie-bradshaw",
			name: "Casa de Carrie Bradshaw",
			emoji: "👠",
			zone: "Greenwich Village",
			image: `${NY_IMAGES_BASE}/Casa-de-Carrie-Bradshaw.png`,
		},
		{
			id: "apartamento-friends",
			name: "Apartamento Friends",
			emoji: "☕",
			zone: "Greenwich Village",
			image: `${NY_IMAGES_BASE}/apartamento-friends.png`,
		},
		{
			id: "museum-mile",
			name: "Museum Mile",
			emoji: "🏛️",
			zone: "Upper East Side",
			image: `${NY_IMAGES_BASE}/Museum-Mile.png`,
		},
		{
			id: "roosevelt-island-tram",
			name: "Roosevelt Island Tram",
			emoji: "🚠",
			zone: "Upper East Side",
			image: `${NY_IMAGES_BASE}/Roosevelt-Island-Tram.png`,
		},
		{
			id: "columbus-circle",
			name: "Columbus Circle",
			emoji: "⭕",
			zone: "Upper West Side",
			image: `${NY_IMAGES_BASE}/Columbus-Circle.png`,
		},
		{
			id: "riverside-park",
			name: "Riverside Park",
			emoji: "🌳",
			zone: "Upper West Side",
			image: `${NY_IMAGES_BASE}/Riverside-Park.png`,
		},
		{
			id: "the-dakota",
			name: "The Dakota",
			emoji: "🏛️",
			zone: "Upper West Side",
			image: `${NY_IMAGES_BASE}/the-dakota.png`,
		},
		{
			id: "radio-city",
			name: "Radio City Music Hall",
			emoji: "🎭",
			zone: "Midtown",
			image: `${NY_IMAGES_BASE}/radio-city-hall.png`,
		},
		{
			id: "catedral-san-patricio",
			name: "Catedral de San Patricio",
			emoji: "⛪",
			zone: "Midtown",
			image: `${NY_IMAGES_BASE}/Catedral-de-San-Patricio.png`,
		},
		{
			id: "chrysler-building",
			name: "Chrysler Building",
			emoji: "🏙️",
			zone: "Midtown",
			image: `${NY_IMAGES_BASE}/Chrysler-Building.png`,
		},
		{
			id: "apollo-theater",
			name: "Apollo Theater",
			emoji: "🎤",
			zone: "Harlem",
			image: `${NY_IMAGES_BASE}/Apollo-Theater.png`,
		},
		{
			id: "casas-brownstone",
			name: "Casas brownstone",
			emoji: "🏘️",
			zone: "Harlem",
			image: `${NY_IMAGES_BASE}/Casas-brownstone.png`,
		},
		{
			id: "gospel",
			name: "Gospel",
			emoji: "🎶",
			zone: "Harlem",
			image: `${NY_IMAGES_BASE}/gospel.png`,
		},
	],

	customBlockTypes: [
		{
			id: "custom-place",
			name: "Nuevo lugar",
			emoji: "📍",
			color: "#6366f1",
			image: `${NY_IMAGES_BASE}/new-place.png`,
		},
		{
			id: "restaurant",
			name: "Restaurante",
			emoji: "🍽️",
			color: "#ef4444",
			image: `${NY_IMAGES_BASE}/restaurante.png`,
		},
		{
			id: "breakfast",
			name: "Desayuno",
			emoji: "🥐",
			color: "#f59e0b",
			image: `${NY_IMAGES_BASE}/breakfast.png`,
		},
		{
			id: "shopping",
			name: "Compras",
			emoji: "🛍️",
			color: "#ec4899",
			image: `${NY_IMAGES_BASE}/shop.png`,
		},
		{
			id: "activity",
			name: "Actividad",
			emoji: "🎭",
			color: "#8b5cf6",
			image: `${NY_IMAGES_BASE}/activities.png`,
		},
		{
			id: "note",
			name: "Nota",
			emoji: "📝",
			color: "#64748b",
			image: `${NY_IMAGES_BASE}/notes.png`,
		},
	],

	cta: {
		text: "¿Quieres saber qué ver, cuánto tiempo dedicar y cómo desplazarte?",
		subtext: "Completa tu viaje con nuestra guía de Nueva York.",
		buttonText: "Ver la guía de Nueva York",
		link: "/",
	},
};

export default NEW_YORK;
